<template>
  <nav
    v-if="isAuthenticated"
    class="navbar navbar-expand-lg navbar-dark bg-dark px-3"
  >
    <div class="container-fluid">
      <!-- Brand Logo -->
      <router-link
        :to="homeRoute"
        class="navbar-brand d-flex align-items-center"
      >
        <svg
          class="bi me-2"
          width="40"
          height="32"
          role="img"
          aria-label="Bootstrap"
        >
          <use xlink:href="#bootstrap"></use>
        </svg>
      </router-link>

      <!-- Navbar Toggler for Mobile -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Navbar Links -->
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item" v-if="isAdminUser">
            <router-link to="/dashboard" class="nav-link text-white">
              Dashboard
            </router-link>
          </li>
          <!--          <li class="nav-item">-->
          <!--            <router-link to="/menu" class="nav-link text-white">-->
          <!--              Menu-->
          <!--            </router-link>-->
          <!--          </li>-->
          <li class="nav-item">
            <router-link to="/orders" class="nav-link text-white">
              Orders
            </router-link>
          </li>
          <!--          <li class="nav-item">-->
          <!--            <router-link to="/orders/all" class="nav-link text-white">-->
          <!--              All Orders-->
          <!--            </router-link>-->
          <!--          </li>-->
          <!--          <li class="nav-item">-->
          <!--            <router-link to="/users" class="nav-link text-white">-->
          <!--              Users-->
          <!--            </router-link>-->
          <!--          </li>-->
          <!--          <li class="nav-item">-->
          <!--            <router-link to="/reports" class="nav-link text-white">-->
          <!--              Reports-->
          <!--            </router-link>-->
          <!--          </li>-->
        </ul>

        <!-- Store & Auth Buttons -->
        <div>
          <button
            v-if="setting?.value?.pickup === false"
            type="button"
            @click="toggleStoreOpen(true)"
            class="btn btn-primary me-2"
          >
            Open Store
          </button>
          <button
            v-if="setting?.value?.pickup === true"
            type="button"
            @click="toggleStoreOpen(false)"
            class="btn btn-danger me-2"
          >
            Close Store
          </button>
          <button type="button" class="btn btn-outline-light me-2">
            {{ user.username }} ({{ user.type }})
          </button>
          <button type="button" @click="handleLogout" class="btn btn-warning">
            Log Out
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "NavbarComponent",
  computed: {
    ...mapGetters("auth", ["isAuthenticated", "authUser"]),
    ...mapGetters("setting", ["setting"]),
    user() {
      return this.authUser || {};
    },
    isAdminUser() {
      return ["admin", "super_user"].includes(this.user.type);
    },
    homeRoute() {
      return this.isAdminUser ? "/dashboard" : "/orders";
    },
  },
  methods: {
    ...mapActions("auth", ["signOut"]),
    ...mapActions("setting", ["fetchSetting", "updateSetting"]),

    async handleLogout() {
      await this.signOut();
      this.$router.push("/signIn");
    },

    async toggleStoreOpen(state) {
      await this.updateSetting({
        key: "store_open",
        value: { ...this.setting.value, pickup: state },
      });
      this.fetchSetting("store_open");
    },
  },
  created() {
    this.fetchSetting("store_open");
  },
};
</script>

<style scoped>
/* Add custom styles if needed */
</style>
